import { GroupDocuments } from "@/pages/groepen/$groupId/documenten"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute("/beheer/groepen/$groupId/documenten/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "groups"),
})

function RouteComponent() {
  const { groupId } = useParams({ from: "/beheer/groepen/$groupId" })

  return <GroupDocuments groupId={Number(groupId)} />
}
